import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceParticulier from './pages/ServiceParticulier';
import ServiceEntreprises from './pages/ServiceEntreprises';
import NettoyageTerrasse from './pages/NettoyageTerrasse';
import ElagageArbres from './pages/ElagageArbres';
import LaTonte from './pages/LaTonte';
import TaillageHaie from './pages/TaillageHaie';
import AmenagementPaysager from './pages/AmenagementPaysager';
import CreditImpotJardin from './pages/CreditImpotJardin';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import DemandeDevis from './pages/DemandeDevis';
import FAQ from './pages/FAQ';
import ConditionsGenerales from './pages/ConditionsGenerales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
// CRM imports
import CRMLogin from './crm/pages/Login';
import CRMDashboard from './crm/pages/Dashboard';
import ContactRequests from './crm/pages/ContactRequests';
import Prospects from './crm/pages/Prospects';
import Clients from './crm/pages/Clients';
import Projects from './crm/pages/Projects';
import Calendar from './crm/pages/Calendar';
import Quotes from './crm/pages/Quotes';
import Invoices from './crm/pages/Invoices';
import Qonto from './crm/pages/Qonto';
import Settings from './crm/pages/Settings';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* CRM Routes - No Header/Footer */}
          <Route path="/crm/login" element={<CRMLogin />} />
          <Route path="/crm/dashboard" element={<CRMDashboard />} />
          <Route path="/crm/contact-requests" element={<ContactRequests />} />
          <Route path="/crm/prospects" element={<Prospects />} />
          <Route path="/crm/clients" element={<Clients />} />
          <Route path="/crm/projects" element={<Projects />} />
          <Route path="/crm/calendar" element={<Calendar />} />
          <Route path="/crm/quotes" element={<Quotes />} />
          <Route path="/crm/invoices" element={<Invoices />} />
          <Route path="/crm/qonto" element={<Qonto />} />
          <Route path="/crm/settings" element={<Settings />} />
          
          {/* Public Site Routes - With Header/Footer */}
          <Route path="/" element={
            <>
              <Header />
              <main>
                <Home />
              </main>
              <Footer />
            </>
          } />
          <Route path="/a-propos-de-nous" element={
            <>
              <Header />
              <main>
                <About />
              </main>
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Header />
              <main>
                <Services />
              </main>
              <Footer />
            </>
          } />
          <Route path="/services/service-particulier" element={
            <>
              <Header />
              <main>
                <ServiceParticulier />
              </main>
              <Footer />
            </>
          } />
          <Route path="/services/service-entreprises" element={
            <>
              <Header />
              <main>
                <ServiceEntreprises />
              </main>
              <Footer />
            </>
          } />
          <Route path="/nettoyage-terrasse-île-de-france" element={
            <>
              <Header />
              <main>
                <NettoyageTerrasse />
              </main>
              <Footer />
            </>
          } />
          {/* Ancienne URL conservée pour compatibilité */}
          <Route path="/services/nettoyage-de-terrasse" element={
            <>
              <Header />
              <main>
                <NettoyageTerrasse />
              </main>
              <Footer />
            </>
          } />
          <Route path="/elagage-arbre-île-de-france" element={
            <>
              <Header />
              <main>
                <ElagageArbres />
              </main>
              <Footer />
            </>
          } />
          {/* Ancienne URL conservée pour compatibilité */}
          <Route path="/services/elagage-darbres" element={
            <>
              <Header />
              <main>
                <ElagageArbres />
              </main>
              <Footer />
            </>
          } />
          <Route path="/services/la-tonte" element={
            <>
              <Header />
              <main>
                <LaTonte />
              </main>
              <Footer />
            </>
          } />
          <Route path="/tailler-haies-evry-courcouronnes" element={
            <>
              <Header />
              <main>
                <TaillageHaie />
              </main>
              <Footer />
            </>
          } />
          {/* Ancienne URL conservée pour compatibilité */}
          <Route path="/services/taillage-de-haie" element={
            <>
              <Header />
              <main>
                <TaillageHaie />
              </main>
              <Footer />
            </>
          } />
          <Route path="/services/amenagement-paysager" element={
            <>
              <Header />
              <main>
                <AmenagementPaysager />
              </main>
              <Footer />
            </>
          } />
          <Route path="/services/credit-dimpot-jardin" element={
            <>
              <Header />
              <main>
                <CreditImpotJardin />
              </main>
              <Footer />
            </>
          } />
          <Route path="/blogs" element={
            <>
              <Header />
              <main>
                <Blogs />
              </main>
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <main>
                <Contact />
              </main>
              <Footer />
            </>
          } />
          <Route path="/demande-devis" element={
            <>
              <Header />
              <main>
                <DemandeDevis />
              </main>
              <Footer />
            </>
          } />
          <Route path="/faq" element={
            <>
              <Header />
              <main>
                <FAQ />
              </main>
              <Footer />
            </>
          } />
          <Route path="/conditions-generales" element={
            <>
              <Header />
              <main>
                <ConditionsGenerales />
              </main>
              <Footer />
            </>
          } />
          <Route path="/politique-de-confidentialite" element={
            <>
              <Header />
              <main>
                <PolitiqueConfidentialite />
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

